import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

import {
  LOAD_ABSENCES,
  CHANGE_ABSENCE,
  DELETE_ABSENCE,
} from './constants';

import {
  loadAbsencesMobileError,
  loadAbsencesMobileSuccess,
  changeAbsenceMobileError,
  changeAbsenceMobileSuccess,
  deleteAbsenceMobileSuccess,
  deleteAbsenceMobileError,
} from './actions';

// utils
import api from "utils/api";
const { endpoint } = api;
import { getObjId } from "utils/helpers/helper.general";
import _local from "utils/localStorageUtils";

export function* loadAbsenceMobile(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = _local.getLocalUser();
    const { role, child } = action;

    let absencesList = false;

    // we get the campaigns linked to the absenceMobile
    if (role == 'parent' && child) {
      absencesList = yield requestWrapper(
        'GET',
        endpoint?.absences?.parent?.list(getObjId(child)),
        '',
        currentUser.token,
      );
    } else if (role == "teacher") {
      absencesList = yield requestWrapper(
        'GET',
        endpoint?.absences?.teacher?.list(getObjId(currentUser)),
        '',
        currentUser.token,
      );
    }

    if (!absencesList) {
      yield put(loadAbsencesMobileSuccess(false));
    } else {
      yield put(loadAbsencesMobileSuccess(absencesList));
    }
  } catch (error) {
    yield put(loadAbsencesMobileError(error));
  }
}

export function* changeAbsenceMobile(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
  
    //const absenceData = yield select(selectAbsenceMobileData());
    const { absenceData } = action;

    let changedAbsenceMobile = false,
      isNew = !absenceData?._id;

    if (absenceData._id === undefined) {
      changedAbsenceMobile = yield requestWrapper(
        'POST',
        endpoint?.absences?.new,
        absenceData,
        currentUser.token
      );
     // notification.success({ message: 'Created' });
    } else {
      changedAbsenceMobile = yield requestWrapper(
        'PATCH',
        endpoint?.absences?.update,
        absenceData,
        currentUser.token
      );
     // notification.success({ message: 'Updated' });
    }

    if (!changedAbsenceMobile) {
      yield put(changeAbsenceMobileSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/absenceMobile/`+absenceData._id });
      }
      yield put(changeAbsenceMobileSuccess(changedAbsenceMobile));
    }
  } catch (error) {
    yield put(changeAbsenceMobileError(error));
  }
}

export function* deleteAbsenceMobile(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();

    const { id } = action;

    const deleteAbsenceMobile = yield requestWrapper(
      'PATCH',
      endpoint?.absences?.archive,
      {
        _id: id
      },
      currentUser.token,
    );

    if (deleteAbsenceMobile) {
      yield put(deleteAbsenceMobileSuccess());
    }
  } catch (error) {
    yield put(deleteAbsenceMobileError(error));
  }
}

export default function* absenceMobileSaga() {
  yield takeLatest(LOAD_ABSENCES, loadAbsenceMobile);
  yield takeLatest(CHANGE_ABSENCE, changeAbsenceMobile);
  yield takeLatest(DELETE_ABSENCE, deleteAbsenceMobile);
}
